import React, { Component } from "react";
import styled from "styled-components";

import { themeColors } from "../../react/sharedStyles";
import { FlexBox } from "../../react/components/LayoutGrid";

const AI_ICON = (
    <svg width="17" height="17" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.98582 3.3706L7.33201 8.33201L2.3706 9.98582C1.87647 10.1505 1.87647 10.8495 2.3706 11.0142L7.33201 12.668L8.98582 17.6294C9.15053 18.1235 9.84947 18.1235 10.0142 17.6294L11.668 12.668L16.6294 11.0142C17.1235 10.8495 17.1235 10.1505 16.6294 9.98582L11.668 8.33201L10.0142 3.3706C9.84947 2.87647 9.15053 2.87647 8.98582 3.3706Z"
            fill="white" />
        <path
            d="M17.2103 14.1957L16.0704 17.0125L13.1929 18.2102C12.9357 18.3172 12.9357 18.6828 13.1929 18.7898L16.0704 19.9875L17.2103 22.8043C17.3159 23.0652 17.6841 23.0652 17.7897 22.8043L18.9296 19.9875L21.8071 18.7898C22.0643 18.6828 22.0643 18.3172 21.8071 18.2102L18.9296 17.0125L17.7897 14.1957C17.6841 13.9348 17.3159 13.9348 17.2103 14.1957Z"
            fill="white" />
    </svg>
);

const AiButton = styled.div`
    background: ${themeColors.aiColor};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    cursor: pointer;
`;

export function AiIcon({ size = 24, contained = false, square = false, color = "white", onClick, style = {} }) {
    let svg = (
        <svg className="ai-icon" width={size} height={size} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8.98582 3.3706L7.33201 8.33201L2.3706 9.98582C1.87647 10.1505 1.87647 10.8495 2.3706 11.0142L7.33201 12.668L8.98582 17.6294C9.15053 18.1235 9.84947 18.1235 10.0142 17.6294L11.668 12.668L16.6294 11.0142C17.1235 10.8495 17.1235 10.1505 16.6294 9.98582L11.668 8.33201L10.0142 3.3706C9.84947 2.87647 9.15053 2.87647 8.98582 3.3706Z"
                fill={color} />
            <path
                d="M17.2103 14.1957L16.0704 17.0125L13.1929 18.2102C12.9357 18.3172 12.9357 18.6828 13.1929 18.7898L16.0704 19.9875L17.2103 22.8043C17.3159 23.0652 17.6841 23.0652 17.7897 22.8043L18.9296 19.9875L21.8071 18.7898C22.0643 18.6828 22.0643 18.3172 21.8071 18.2102L18.9296 17.0125L17.7897 14.1957C17.6841 13.9348 17.3159 13.9348 17.2103 14.1957Z"
                fill={color} />
        </svg>
    );

    if (contained) {
        return (
            <AiButton onClick={onClick} style={{ width: size * 1.5, height: size * 1.5, ...style }}>{svg}</AiButton>
        );
    } else if (square) {
        return (
            <AiButton onClick={onClick} style={{ width: size, height: size, borderRadius: 0, ...style }}>{svg}</AiButton>
        );
    } else {
        return <FlexBox center middle style={style}>{svg}</FlexBox>;
    }
}

export function AiPhotoIcon({ size = 22, color = "white", onClick, style = {} }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M22.7035 7.58865L18.7344 6.26561L17.4113 2.29648C17.2796 1.90117 16.7204 1.90117 16.5887 2.29648L15.2656 6.26561L11.2965 7.58865C10.9012 7.72042 10.9012 8.27958 11.2965 8.41135L15.2656 9.73439L16.5887 13.7035C16.7204 14.0988 17.2796 14.0988 17.4113 13.7035L18.7344 9.73439L22.7035 8.41135C23.0988 8.27958 23.0988 7.72042 22.7035 7.58865Z"
                fill={color} />
            <path
                d="M13.826 13.7425L11.3222 12.7293L10.2576 10.1715C10.1625 9.94285 9.83753 9.94285 9.74238 10.1715L8.67778 12.7293L6.17398 13.7424C5.94201 13.8363 5.94201 14.1637 6.17398 14.2575L8.67778 15.2707L9.74238 17.8285C9.83753 18.0572 10.1625 18.0572 10.2576 17.8285L11.3222 15.2707L13.826 14.2575C14.058 14.1637 14.058 13.8363 13.826 13.7425Z"
                fill={color} />
            <path d="M14 5H9.87988L8.0498 7H4V19H20V11H22V19C22 20.1 21.1 21 20 21H4C2.9 21 2 20.1 2 19V7C2 5.9 2.9 5 4 5H7.16992L9 3H14V5Z" fill={color} />
        </svg>
    );
}

const Container = styled.div`
    background: ${themeColors.aiColor};
    border-radius: 50%;
    width: 26px !important;
    height: 26px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor pointer;
`;

export class SlideAiButton extends Component {
    render() {
        const { onClick } = this.props;
        return (
            <Container onClick={onClick}>
                {AI_ICON}
            </Container>
        );
    }
}

